export const KEYWORDS_CAMPAIGN_HOME_STATE = "ranktracker.home";
export const KEYWORDS_REPORTS_PAGE = "ranktracker.keywords";
export const RT_CREATE_CAMPAIGN_WIZARD_STATE = "ranktracker.wizard";

export const demoCampaignsImagesMap = {
    Retail: "images/keywords-campaigns/files/rayBanDemoCampaign.svg",
    "Car Rental": "images/keywords-campaigns/files/sixtDemoCampaign.svg",
    Software: "images/keywords-campaigns/files/hubspotDemoCampaign.svg",
};
